import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.svg';

const NAV_LINKS = [
  { label: 'Home',       to: '/',            end: true  },
  { label: 'About',      to: '/about',       end: false },
  { label: 'Services',   to: '/services',    end: false },
  { label: 'Solutions',  to: '/solutions/enterprise-software', end: false },
  { label: 'Products',   to: '/products',    end: false },
  { label: 'Industries', to: '/industries',  end: false },
  { label: 'Technology', to: '/technology',  end: false },
  { label: 'Our Process',to: '/our-process', end: false },
  { label: 'Careers',    to: '/careers',     end: false },
  { label: 'Contact',    to: '/contact',     end: false },
];

function Header() {
  const [menuOpen, setMenuOpen]   = useState(false);
  const [scrolled, setScrolled]   = useState(false);
  const location = useLocation();

  /* Scroll to top on every route change */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    setMenuOpen(false);
  }, [location.pathname]);

  /* Transparent ↔ white header on scroll */
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
      if (window.scrollY > 80 && menuOpen) setMenuOpen(false);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [menuOpen]);

  /* Close menu when viewport widens above breakpoint */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClose = () => setMenuOpen(false);

  return (
    <header
      className={`site-header${scrolled ? ' site-header--scrolled' : ''}`}
      role="banner"
    >
      <div className="container">
        <nav className="site-nav" aria-label="Primary navigation">

          {/* Brand logo */}
          <Link to="/" className="site-logo" onClick={handleClose} aria-label="Quantum Stack – home">
            <img src={logo} alt="Quantum Stack" className="site-logo__img" />
          </Link>

          {/* Hamburger toggle (mobile) */}
          <button
            className={`nav-toggle${menuOpen ? ' nav-toggle--open' : ''}`}
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-expanded={menuOpen}
            aria-controls="main-nav-list"
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          >
            <span className="nav-toggle__bar" aria-hidden="true" />
            <span className="nav-toggle__bar" aria-hidden="true" />
            <span className="nav-toggle__bar" aria-hidden="true" />
          </button>

          {/* Navigation links */}
          <ul
            id="main-nav-list"
            className={`nav-list${menuOpen ? ' nav-list--open' : ''}`}
          >
            {NAV_LINKS.map(({ label, to, end }) => (
              <li key={to} className="nav-item">
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    `nav-link${isActive ? ' nav-link--active' : ''}`
                  }
                  onClick={handleClose}
                >
                  {label}
                </NavLink>
              </li>
            ))}

            <li className="nav-item nav-item--cta">
              <Link
                to="/contact"
                className="btn-primary-brand btn-sm"
                onClick={handleClose}
              >
                Free Consultation
              </Link>
            </li>
          </ul>

        </nav>
      </div>
    </header>
  );
}

export default Header;
